var _style, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFamilies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;enable-background:new    ;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_",
    transform: "translate(0.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-group",
    transform: "translate(20.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M-9.2-39.5c0,0.4-0.3,0.7-0.7,0.7h-4.3c-0.4,0-0.7-0.3-0.7-0.7V-46c0-0.8-0.6-1.4-1.4-1.4h-0.7 c-0.4,0-0.7-0.3-0.7-0.7v-3.6c0-3.2,2.6-5.8,5.8-5.8c1.9,0,3.7,1,4.7,2.5l0,0c-1.1,1.3-1.8,2.9-1.8,4.7v4.4v0.7V-39.5L-9.2-39.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st0",
    d: "M13.8-48.1c0,0.4-0.3,0.7-0.7,0.7h-0.7c-0.8,0-1.4,0.6-1.4,1.4v6.5c0,0.4-0.3,0.7-0.7,0.7H5.9 c-0.4,0-0.7-0.3-0.7-0.7v-5.8v-0.4v-4.6c0-1.8-0.7-3.5-1.8-4.7l0,0c1-1.5,2.8-2.5,4.7-2.5c3.2,0,5.8,2.6,5.8,5.8V-48.1L13.8-48.1 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-58.9c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3C-6.3-60.9-4.4-58.9-2-58.9L-2-58.9z M-2-66.1 c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9C-4.9-64.8-3.6-66.1-2-66.1L-2-66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1-60.4c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3C3.8-62.3,5.7-60.4,8.1-60.4L8.1-60.4z  M8.1-67.6c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9C5.2-66.3,6.5-67.6,8.1-67.6L8.1-67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.1-60.4c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3C-16.4-62.3-14.5-60.4-12.1-60.4L-12.1-60.4z  M-12.1-67.6c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9C-15-66.3-13.7-67.6-12.1-67.6L-12.1-67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1-58.9c-2.4,0-4.4,1.2-5.8,2.9c0,0,0,0,0,0c-1.2-0.9-2.7-1.5-4.3-1.5s-3.1,0.6-4.3,1.5c0,0,0,0,0,0 c-1.3-1.8-3.4-2.9-5.8-2.9c-4,0-7.2,3.2-7.2,7.2v3.6c0,1.2,1,2.2,2.2,2.2h0.7v6.5c0,1.2,1,2.2,2.2,2.2h4.3c1.2,0,2.2-1,2.2-2.2 v-3.7c0.2,0.1,0.5,0.1,0.7,0.1h0.7v7.9c0,1.2,1,2.2,2.2,2.2h4.3c1.2,0,2.2-1,2.2-2.2v-7.9H3c0.3,0,0.5-0.1,0.7-0.1v3.7 c0,1.2,1,2.2,2.2,2.2h4.3c1.2,0,2.2-1,2.2-2.2V-46h0.7c1.2,0,2.2-1,2.2-2.2v-3.6C15.3-55.7,12.1-58.9,8.1-58.9L8.1-58.9z  M-9.2-39.5c0,0.4-0.3,0.7-0.7,0.7h-4.3c-0.4,0-0.7-0.3-0.7-0.7V-46c0-0.8-0.6-1.4-1.4-1.4h-0.7c-0.4,0-0.7-0.3-0.7-0.7v-3.6 c0-3.2,2.6-5.8,5.8-5.8c1.9,0,3.7,1,4.7,2.5l0,0c-1.1,1.3-1.8,2.9-1.8,4.7v4.4v0.7V-39.5L-9.2-39.5z M3-44.5H2.3 c-0.8,0-1.4,0.6-1.4,1.4v7.9c0,0.4-0.3,0.7-0.7,0.7h-4.3c-0.4,0-0.7-0.3-0.7-0.7v-7.9c0-0.8-0.6-1.4-1.4-1.4H-7 c-0.4,0-0.7-0.3-0.7-0.7v-5c0-3.2,2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8v5C3.8-44.8,3.4-44.5,3-44.5L3-44.5z M13.8-48.1 c0,0.4-0.3,0.7-0.7,0.7h-0.7c-0.8,0-1.4,0.6-1.4,1.4v6.5c0,0.4-0.3,0.7-0.7,0.7H5.9c-0.4,0-0.7-0.3-0.7-0.7v-5.8v-0.4v-4.6 c0-1.8-0.7-3.5-1.8-4.7l0,0c1-1.5,2.8-2.5,4.7-2.5c3.2,0,5.8,2.6,5.8,5.8V-48.1L13.8-48.1z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamilies);
export default __webpack_public_path__ + "static/media/icon-families.c9688eab49a758aea53e8e99fc92c7dd.svg";
export { ForwardRef as ReactComponent };